import { Injectable, Inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';

@Injectable({
  providedIn: 'root'
})
export class StorageService {

  constructor(@Inject(PLATFORM_ID) private platformId: any) {}

  private isBrowser(): boolean {
    return isPlatformBrowser(this.platformId);
  }

  getUserRoles() {
    if (this.isBrowser()) {
      return sessionStorage.getItem('roles');
    }
    return null;
  }

  setOpenChilds(indexes: any): void {
    if (this.isBrowser()) {
      sessionStorage.setItem('openChilds', JSON.stringify(indexes));
    }
  }

  getOpenChilds() {
    if (this.isBrowser()) {
      return JSON.parse(sessionStorage.getItem('openChilds'));
    }
    return null;
  }

  setUserRoles(roles: string): void {
    if (this.isBrowser()) {
      sessionStorage.setItem('roles', roles);
    }
  }

  setTenantKey(tenantKey: string): void {
    if (this.isBrowser()) {
      sessionStorage.setItem('tenantKey', tenantKey);
    }
  }

  getToken() {
    if (this.isBrowser()) {
      return JSON.parse(sessionStorage.getItem('userData'))?.['token'];
    }
  }

  getTenantKey() {
    if (this.isBrowser()) {
      return sessionStorage.getItem('tenantKey');
    }
    return null;
  }

  getAccessToken() {
    if (this.isBrowser()) {
      return sessionStorage.getItem('accessToken');
    }
    return null;
  }
}